import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Fade from "react-reveal/Fade";

import p from '../../img/Home/phoneinvest.png'

function Investing () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative flex flex-col xl:flex-row gap-[20px] xl:h-[430px] xl:w-full">
                <div className="flex flex-col gap-[10px] w-full">
                    <div className="bg-[#FFFFFF] rounded-[20px] w-full h-full flex flex-col p-[20px] xl:px-[36px] xl:pt-[50px] relative">
                        <div className="flex gap-[10px] items-center">
                            <div className="w-[12px] h-[12px] rounded-full bg-[#CEDFF2]"></div>
                            <p className="open-sans text-[#000E59] font-[700] text-[16px] xl:text-[23px]">{t('home.63')}</p>
                        </div>
                        <p className="open-sans text-[14px] xl:text-[18px] xl:mt-[10px] text-[#000E59] ml-[22px]">{t('home.64')}</p>
                        <p className="text-[12px] xl:text-[14px] text-[#000E59] open-sans xl:absolute bottom-[14px] right-[14px] ml-auto mt-[20px] xl:mt-0">{t('home.65')}</p>
                    </div>
                    <div className="bg-[#FFFFFF] rounded-[20px] w-full h-full flex flex-col p-[20px] xl:px-[36px] xl:pt-[50px] relative">
                        <div className="flex gap-[10px] items-center">
                            <div className="w-[12px] h-[12px] rounded-full bg-[#CEDFF2]"></div>
                            <p className="open-sans text-[#000E59] font-[700] text-[16px] xl:text-[23px]">{t('home.66')}</p>
                        </div>
                        <p className="open-sans text-[14px] xl:text-[18px] mt-[10px] text-[#000E59] ml-[22px]">{t('home.67')}</p>
                    </div>
                </div>
                <div className="bg-[#CEDFF2] rounded-[20px] w-full">
                    <Fade><img src={p} alt="" className="w-full h-full object-cover"/></Fade>
                </div>
                <div className="bg-[#FFFFFF] rounded-[20px] w-full flex flex-col p-[20px] xl:px-[36px] xl:pt-[50px] relative">
                    <div className="flex gap-[10px] items-center">
                    <div className="w-[12px] h-[12px] rounded-full bg-[#CEDFF2]"></div>
                        <p className="open-sans text-[#000E59] font-[700] text-[16px] xl:text-[23px]">{t('home.68')}</p>
                    </div>
                    <p className="open-sans text-[14px] xl:text-[18px] mt-[10px] text-[#000E59] ml-[22px]">{t('home.69')}</p>
                    <p className="text-[12px] xl:text-[14px] text-[#000E59] open-sans ml-auto xl:absolute bottom-[14px] right-[14px]">{t('home.70')}</p>
                </div>
            </div>  
        </div>
    );
}

export default Investing;